import moment from 'moment';
import './TransporterModal.scss';
import './ApprovalsStatusModal.scss';

const STATUS_CLASS = {
    APPROVED: 'approval-status--approved',
    REJECTED: 'approval-status--rejected',
    PENDING:  'approval-status--pending',
};

const ApprovalsStatusModal = ({ visible, onClose, approvalsList = [] }) => {
    if (!visible) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-card approvals-modal-card">
                <button className="modal-close" onClick={onClose}>×</button>

                <h3>Approval Status</h3>

                <table className="modal-table">
                    <thead>
                        <tr>
                            <th>Level</th>
                            <th>Emails</th>
                            <th>Status</th>
                            <th>Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        {approvalsList.map((item) => (
                            <tr key={item.level}>
                                <td>L{item.level}</td>
                                <td>{item.emails?.join(', ')}</td>
                                <td>
                                    <span className={`approval-status ${STATUS_CLASS[item.status] || ''}`}>
                                        {item.status}
                                    </span>
                                </td>
                                <td>{item.date ? moment(item.date).format('DD MMM YYYY, hh:mm A') : '—'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="modal-footer">
                    <button className="close-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default ApprovalsStatusModal;
